import React from 'react';
import PropTypes from 'prop-types';

import SearchBar from '../Shared/SearchBar';

const CityBanner = ({services, city}) => (
    <div className="promo category main-page">
        <div className="text-frame landing container-fluid w-800">
            <h1>{city.name.toLowerCase().ucFirst()}</h1>
            <h2>Find expert tutors for local and online tutoring in {city.name.toLowerCase().ucFirst()}.</h2>

            <div className="row">
                <div className="col-md-12">
                    <SearchBar services={services} searchPlaceholder={'What do you want to learn?'}/>
                </div>
            </div>
        </div>
    </div>
);

CityBanner.propTypes = {
    city: PropTypes.shape({
        name: PropTypes.string.isRequied
    }).isRequired,
};

export default CityBanner;
